import { render } from "./homeContent.vue?vue&type=template&id=4b389a00&scoped=true"
import script from "./homeContent.vue?vue&type=script&lang=js"
export * from "./homeContent.vue?vue&type=script&lang=js"

import "./homeContent.vue?vue&type=style&index=0&id=4b389a00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b389a00"]])

export default __exports__